










import { Component, Prop, Vue } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";

@Component({
  components: { VueRecaptcha }
})
export default class RecaptchaContainer extends Vue {
  @Prop() site_key!: string;
  @Prop() secret!: string;
  @Prop() verify!: (res?: any) => void;
  @Prop() error!: () => void;
  @Prop() expire!: () => void;

  onVerify(res?: any) {
    fetch(
      "https://us-central1-balance-257015.cloudfunctions.net/verifyRecaptcha?response=" +
        res,
      {
        method: "GET"
      }
    ).then(async (res: any) => {
      res = await res.json();
      this.verify(res.success);
    });
  }

  onExpire() {
    this.expire();
  }

  onError() {
    this.error();
  }
}

const component = RecaptchaContainer;
